/*import { applyMiddleware } from 'redux';
import { legacy_createStore as createStore } from 'redux';
import { thunk } from 'redux-thunk';
import userReducer from './reducer';

export default createStore(
    userReducer,
    applyMiddleware(thunk)
);*/

import { applyMiddleware } from 'redux';
import { legacy_createStore as createStore } from 'redux';
import { thunk } from 'redux-thunk';

import userReducer from './reducer';

const middlewares = [thunk];

export default createStore(userReducer, applyMiddleware(...middlewares));